module.exports = __webpack_public_path__ + "static/img/16areaB_2.aa62122.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/16areaB_2.png
// module id = 1140
// module chunks = 1